module.exports = __webpack_public_path__ + "static/media/bg2.25e58120.jpg";